import { render, staticRenderFns } from "./EmailAddress.vue?vue&type=template&id=118db38c"
import script from "./EmailAddress.vue?vue&type=script&lang=ts"
export * from "./EmailAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports